import React, { useEffect, useState } from 'react'
import Layout from '../../Components/Layout'
import LightText, { BigerTexts, DarkBold, lastOne, LighterBold, pendingtxt } from '../../Assets/CSS/Text';
import { useNavigate, useParams } from 'react-router-dom';
import { Icon } from "@iconify/react";
import '../../Assets/CSS/Offboarding.css'
import { Acceptbtn, Continuebtn, Newbtn, Rejectbtn } from '../../Assets/CSS/Button';
import { getUserRole } from './Offboarding';
import axios from 'axios';
import toast from 'react-hot-toast';
import DatePicker from 'react-datepicker';


const OffboardProfile = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [offboarding, setOffboarding] = useState(null);
const [comment, setComment] = useState("");
const [lastWorkingDay, setLastWorkingDay] = React.useState(
    offboarding?.lastWorkingDay || ""
  );
  useEffect(() => {
    if (offboarding?.lastWorkingDay) {
      setLastWorkingDay(offboarding.lastWorkingDay);
    }
  }, [offboarding]);

const [myTasks, setMyTasks] = useState([]);
const [loadingTasks, setLoadingTasks] = useState(false);

     const token = localStorage.getItem("token");
const { roles = [] } = getUserRole(token);

// priority: IT & FINANCE first, then MANAGER
const ROLE_PRIORITY = ["ROLE_IT_MANAGER", "ROLE_FINANCE", "ROLE_MANAGER"];

const activeRole = ROLE_PRIORITY.find(r => roles.includes(r)) || null;



const fetchOffboardingById = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setOffboarding(response.data);
  } catch (error) {
    console.error("Error fetching offboarding details", error);
    toast.error("Failed to load offboarding details");
  }
};

useEffect(() => {
  if (id) {
    fetchOffboardingById();
  }
}, [id]);
useEffect(() => {
  if (!offboarding || !activeRole) return;

  let tasks = offboarding.tasks || [];

  // Filter by role
  if (activeRole === "ROLE_IT_MANAGER") {
    tasks = tasks.filter(t => t.department === "IT");
  } else if (activeRole === "ROLE_FINANCE") {
    tasks = tasks.filter(t => t.department === "Finance");
  }

  // Map UI state
  const formattedTasks = tasks.map(task => ({
    ...task,
    completed: task.status === "COMPLETED",
  }));

  setMyTasks(formattedTasks);
}, [offboarding, activeRole]);

const completeTask = async (taskId) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/tasks/${taskId}/status`,
      {
        status: "COMPLETED",
        comments: "Completed by department",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    toast.success("Task marked as completed");

    // 🔄 Update UI state after success
    setMyTasks(prev =>
      prev.map(task =>
        task.taskId === taskId
          ? { ...task, status: "COMPLETED", completed: true }
          : task
      )
    );

  } catch (error) {
    console.error("Failed to complete task", error);
    toast.error(
      error?.response?.data?.message || "Failed to complete task"
    );
  }
};



  



console.log("Active Role:", activeRole);




    const empDetails = [
  { label: "Employee Name", value: offboarding?.employeeName || "-", icon: "material-symbols:person-outline" },
  { label: "Employee ID", value: offboarding?.employeeCode || "-", icon: "mdi:card-account-details-outline" },
  { label: "Department", value: offboarding?.department || "-", icon: "mdi:office-building" },
  { label: "Designation", value: offboarding?.designation || "-", icon: "mdi:briefcase-outline" },
];


const submitDecision = async (decision) => {
    try {
      const token = localStorage.getItem("token");

      const action =
        decision === "APPROVED" ? "approve" : "reject";
      const payload = {
        decision,               // APPROVED / REJECTED
        comments: comment,
        lastWorkingDay,         // 🔥 UPDATED DATE
      };
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/${id}/${action}`,
        payload,
        // {
        //   decision,      // must be APPROVED or REJECTED
        //   comments: comment,
        // },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(`Request ${decision.toLowerCase()} successfully`);
      navigate(-1);

    } catch (error) {
      console.error("Decision failed:", error);

      toast.error(
        error?.response?.data?.message || "Action failed"
      );
    }
  };




const toggleTaskStatus = (index) => {
  setMyTasks(prev =>
    prev.map((task, i) =>
      i === index ? { ...task, completed: !task.completed } : task
    )
  );
};


const toggleTaskStatusById = (taskId) => {
  setMyTasks(prev =>
    prev.map(task =>
      task.taskId === taskId
        ? { ...task, completed: !task.completed }
        : task
    )
  );
};


const allTasksCompleted =
  myTasks.length > 0 && myTasks.every(t => t.completed);

  const saveCheckedTasks = async () => {
  const completedTasks = myTasks.filter(t => t.completed);

  for (const task of completedTasks) {
    await completeTask(task.taskId);
  }
};


console.log("clearance : ",toggleTaskStatusById)

const OffboardDetails =
    [
      { label: "Last Working Day", key: "lastWorkingDay" },
      { label: "Offboarding Type", key: "offboardingType" },
      { label: "Reason for Leaving", key: "reason" },
      { label: "Additional Notes", key: "additionalNotes" },
    ]
const isDateDisabled =
  activeRole === "ROLE_FINANCE" || activeRole === "ROLE_IT_MANAGER";



    return (
        <Layout>
            <div className="backgound-main-content px-md-3 px-sm-0">


                {/* Back Button */}
                <div className='d-flex justify-content-between align-item-center'
          style={{ paddingRight: '150px' }}>
                <div className="d-flex gap-2 align-items-center mt-2">
                    <Icon
                        icon='akar-icons:arrow-left'
                        style={{ color: '#909090' }}
                        onClick={() => navigate(-1)}
                    />
                    <h6 style={LighterBold}>Back</h6>
                </div>

                <div >
            <button className="admin-add-employee-btn"
              // onClick={() => navigate("/off-boardingDetails")}
              onClick={() => navigate(`/off-boardingDetails/${offboarding.requestId}`)}
              
              >
              View Status
            </button>
          </div>

                </div>

                {/* Heading + Badge */}
                <div className="d-flex flex-wrap align-items-center gap-2 mt-3">
                    <h6 style={{ ...BigerTexts, margin: 0 }}>{offboarding?.employeeName || "-"}</h6>
                    <span
                        className="px-3 py-1"
                        style={{
                            ...pendingtxt,
                            backgroundColor: "#FFFED9",
                            borderRadius: "6px",
                        }}
                    >
                        {offboarding?.status
    ?.replaceAll("_", " ")
    ?.toLowerCase()
    ?.replace(/\b\w/g, (c) => c.toUpperCase()) || "-"}
                    </span>
                </div>

                <p style={LightText}>Review the offboarding request and provide your decision</p>

                {/* Employee Details */}
                <h6 style={lastOne}>Employee Details</h6>
                <div className="row">
                    {empDetails.map((item, index) => (
                        <div className="col-md-6 col-12 mb-3" key={index}>
                            <div className="emp-card p-2 d-flex gap-3">
                                <Icon icon={item.icon} style={{ color: '#B8B8B8', fontSize: '27px' }} />
                                <div>
                                    <h6 style={LightText} className="mb-1">{item.label}</h6>
                                    <h6 style={DarkBold} className="mb-0">{item.value}</h6>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>


                <div className="col-md-9 col-12">
                    <h6 className="mt-4" style={lastOne}>Offboarding Details</h6>


<div className="emp-off-card p-3">
            {OffboardDetails.map((item, index) => (
    <div key={index} className="d-flex justify-content-between flex-wrap py-1">
      <h6 style={{ ...LightText, margin: 0, width: "200px" }}>
        {item.label}

      </h6>

{/* CONDITIONAL FIELD */}

                {item.key === "lastWorkingDay" ? (
                  <div className="position-relative" style={{ maxWidth: "200px" }}>


<DatePicker
  selected={lastWorkingDay ? new Date(lastWorkingDay) : null}
  onChange={(date) => {
    if (!date || isDateDisabled) return;

    const selectedDate = date.toISOString().split("T")[0];
    setLastWorkingDay(selectedDate);
  }}
  dateFormat="yyyy-MM-dd"
  disabled={isDateDisabled}
  customInput={
    <div
      className="form-control d-flex align-items-center justify-content-between"
      style={{
        cursor: isDateDisabled ? "not-allowed" : "pointer",
        width: "145px",
        backgroundColor: isDateDisabled ? "#F5F5F5" : "#fff",
        opacity: isDateDisabled ? 0.7 : 1,
      }}
    >
      <span>
        {lastWorkingDay || "YYYY-MM-DD"}
      </span>
      <Icon
        icon="uil:calendar"
        style={{
          fontSize: "18px",
          color: isDateDisabled ? "#B0B0B0" : "#00AFEF",
        }}
      />
    </div>
  }
/>




                  </div>

                ) : (
                  <h6 style={{ ...DarkBold, margin: 0, flex: 1 }}>
                    {offboarding?.[item.key] || "-"}
                  </h6>
                )}
              </div>
            ))}
          </div>

        </div>


              {(activeRole === "ROLE_IT_MANAGER" || activeRole === "ROLE_FINANCE") && (
  <div className="col-md-9 mt-4">
    <h6>My Tasks</h6>

    {loadingTasks ? (
      <p style={LightText}>Loading tasks...</p>
    ) : myTasks.length === 0 ? (
      <p style={LightText}>No tasks assigned</p>
    ) : (
      <div className="p-1">
       {myTasks.map((task) => (
  <div
    key={task.taskId}
    className="d-flex justify-content-between align-items-center p-2 mb-2 rounded"
    style={{
      backgroundColor: task.completed ? "#EFFFF5" : "#F8F8F8",
    }}
  >
    <div className="d-flex align-items-center gap-2">
      <input
        type="checkbox"
        checked={task.completed}
        // disabled={task.completed}
         onChange={() => toggleTaskStatusById(task.taskId)}
      />
      <span>{task.title}</span>
    </div>

    {task.completed && (
      <Icon
        icon="material-symbols:check-rounded"
        style={{ color: "#22C55E", fontSize: "22px" }}
      />
    )}
  </div>
))}

      </div>
    )}
  </div>
)}

                    <>
                        {/* Assigned Assets */}
                        {activeRole === "ROLE_MANAGER" && (
  <div className="col-md-9 col-12">
    <h6 className="mt-4" style={lastOne}>Assigned Assets</h6>
    <ol className="emp-assets">
      <li style={DarkBold}>Laptop Dell Model name</li>
      <li style={DarkBold}>ID Card</li>
    </ol>
  </div>
)}

                    </>
                


                {/* Comments */}
                <div className="col-md-9 col-12">
                    <h6 className="mt-4" style={lastOne}>Comments</h6>
                    <textarea
                        className="form-control"
                        rows="4"
                        style={{ borderRadius: '10px', border: ' 1px solid #C8C8C8' }}
                        placeholder="Enter your comments here..."
                         value={comment}
  onChange={(e) => setComment(e.target.value)}
                        ></textarea>
                </div>

                {/* Buttons */}
              {activeRole === "ROLE_MANAGER" && (
  <div className="d-flex flex-wrap gap-3 mt-3">

<button style={Acceptbtn} onClick={() => submitDecision("APPROVED")}>
  Approve
</button>

<button  style={Rejectbtn} onClick={() => submitDecision("REJECTED")}>
  Reject
</button>


  </div>
)}

              

{(activeRole === "ROLE_IT_MANAGER" || activeRole === "ROLE_FINANCE") && (
  <div className="d-flex gap-3 mt-3">
    
    <button
  style={{ ...Newbtn, padding: '10px 60px' }}
  onClick={async () => {
    try {
      await saveCheckedTasks(); // ✅ only checked tasks
      toast.success("Progress saved");
      navigate(-1);
    } catch (e) {
      toast.error("Failed to save progress");
    }
  }}
>
  Save & Exit
</button>


    

<button
  style={{ ...Acceptbtn, padding: '10px 60px' }}
  disabled={!allTasksCompleted}
  onClick={async () => {
    try {
      if (!allTasksCompleted) {
        toast.error("Please complete all tasks first");
        return;
      }

      // 1️⃣ Complete all checked tasks
      await saveCheckedTasks();

      // 2️⃣ Then submit manager decision
      await submitDecision("APPROVED");

      toast.success("Tasks completed & approved successfully");
      navigate(-1);

    } catch (e) {
      toast.error("Failed to complete offboarding");
    }
  }}
>
  Mark Completed
</button>


  </div>
)}


                

            </div>
        </Layout>
    );
};

export default OffboardProfile

